import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { RootState } from "../app/store";
import { Paths } from "../router/Paths";
import CachedItem, { LoadCachedItem } from "config/cache";

export default function useCheckAuthentication() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state: RootState) => state.user);
  const isPublicShareRoute = location.pathname.startsWith("/share/");
  const isDealerHost = window.location.hostname
    .toLowerCase()
    .startsWith("dealer.");
  const isDealerRoute =
    isDealerHost || location.pathname.startsWith("/dealer/");

  const loadUser = () => {
    const data = LoadCachedItem(CachedItem.user, true);
    return data;
  };

  const loadToken = () => {
    const data = LoadCachedItem(CachedItem.token, true);
    return data;
  };

  useEffect(() => {
    if (isPublicShareRoute || isDealerRoute) return;

    if (!user) {
      const loadedUser = loadUser();
      const loadedToken = loadToken();
      if (!loadedUser || !loadedToken) {
        localStorage.removeItem(CachedItem.user);
        localStorage.removeItem(CachedItem.token);
        navigate(Paths.login);
      }
    }
  }, [isDealerRoute, isPublicShareRoute, navigate, user]);

  return undefined;
}
